<template>
  <div id="nav">
    <div class="nr">
      <div class="center">
        <div class="tit">
          <h2>會員中心</h2>
        </div>
        <!-- TODO 確認樣式 -->
        <CompMarquee></CompMarquee>
        <div class="list">
          <router-link style="cursor: pointer" to="/mem/info">
            基本資料 <i>&gt;</i>
          </router-link>
          <router-link style="cursor: pointer" to="/mem/auth">
            認證中心 <i>&gt;</i>
          </router-link>
          <router-link style="cursor: pointer" to="/mem/recbuydri">
            直購商品記錄 <i>&gt;</i>
          </router-link>
          <router-link
            v-if="!webMode"
            style="cursor: pointer"
            to="/mem/recbuysti"
          >
            直購貼紙記錄 <i>&gt;</i>
          </router-link>
          <router-link v-if="!webMode" style="cursor: pointer" to="/mem/reclot">
            中獎紀錄/提領 <i>&gt;</i>
          </router-link>
          <router-link
            v-if="!webMode"
            style="cursor: pointer"
            to="/mem/recpritake"
          >
            領獎紀錄/訂單 <i>&gt;</i>
          </router-link>
          <router-link style="cursor: pointer" to="/download">
            APP下載 <i>&gt;</i>
          </router-link>
          <a @click="logout" style="cursor: pointer"> 登出 <i>&gt;</i> </a>
        </div>
      </div>
      <CompFoot />
    </div>
    <div class="shadow" v-if="false"></div>
    <div class="pop" v-if="false">
      <i class="close" @click="closePop"></i>
      <div class="txt">
        <p>※抽獎方式：</p>
        <p>1.福利金幣抽獎區。</p>
        <p>一。參加每項抽獎獎品所需福利金幣數量皆由主辦單位設定。</p>
        <p>
          二。每項抽獎獎區皆為人人有獎，其各獎區獎品內容將顯示於各抽獎區獎項內，
        </p>
        <p>普獎為『福利銀幣』。</p>
        <p>2.福利銀幣抽獎區。</p>
        <p>一。參加每項抽獎獎品所需福利銀幣數量皆由主辦單位設定。</p>
        <p>
          二。每項抽獎獎區皆為人人有獎，其各獎區獎品內容將顯示於各抽獎區獎項內
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "ComNav",
  components: {
    CompMarquee: require("@/components/parts/Marquee").default,
    CompFoot: require("@/components/parts/Foot").default,
  },
  computed: {
    ...mapGetters({
      loginState: "loginState",
      webMode: "webMode",
    }),
    ...mapState({
      userInfo: (state) => state.member.userInfo,
    }),
  },
  methods: {
    closePop() {
      $(".shadow").fadeOut(100);
      $(".pop").fadeOut(200);
    },
    async logout() {
      await this.$store.dispatch("member/logout");
    },
  },
};
</script>
<style scoped>
@import "~@/assets/css/nav.css";
</style>
